var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.managerRole
      ? _c("span", { staticClass: "w-0" })
      : _c(
          "div",
          { staticClass: "flex w-48 items-center px-2 py-1" },
          [
            _c("SchedulerItemAvatar", {
              attrs: { avatar: _vm.avatar, title: _vm.name, small: false },
            }),
            _c("span", { staticClass: "font-semibold ml-2 truncate" }, [
              _vm._v(_vm._s(_vm.name)),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }